import { Spin } from "antd-v5";
import classNames from "classnames";
import { noop } from "lodash";
import React, { ReactNode, forwardRef } from "react";

import "./ACButton.less";

export interface ACButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "type"> {
  type?: ButtonType;
  size?: ButtonSize;
  children: ReactNode;
  loading?: boolean;
  leftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
  iconOnly?: boolean;
  btnType?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
  block?: boolean;
  testId?: string;
}

type ButtonType = "primary" | "secondary" | "outline" | "ghost" | "danger";

type ButtonSize = "sm" | "md";

const ACButton = forwardRef<HTMLButtonElement, ACButtonProps>(function ACButton(
  {
    type = "primary",
    size = "md",
    children,
    disabled,
    loading,
    className,
    leftIcon,
    rightIcon,
    onClick,
    iconOnly,
    btnType = "button", // ENG-50102 - type as button to avoid form sumbit trigger
    block,
    testId,
    ...restProps
  },
  ref,
) {
  const computeTestId = () => {
    if (testId) return testId;
    return typeof children === "string"
      ? `button-${children.toLowerCase().replace(/\s+/g, "-")}`
      : "";
  };
  return (
    <button
      ref={ref}
      disabled={disabled}
      className={classNames(
        "ac-button",
        `ac-button-${size}`,
        `ac-button-${type}`,
        {
          "ac-button-disabled": disabled,
          "ac-button-loading": loading,
          "ac-button-icon-only": iconOnly,
          "ac-button-block": block,
        },
        className,
      )}
      onClick={disabled || loading ? noop : onClick}
      type={btnType}
      data-test-id={computeTestId()}
      {...restProps}
    >
      <Spin prefixCls="ac-button-spin" spinning={loading === true}>
        <div className="ac-button-content">
          {leftIcon}
          <span className="ac-button-label">{children}</span>
          {rightIcon}
        </div>
      </Spin>
    </button>
  );
});

export default ACButton;
